<template>
  <div>
    <div class="main-header">
      <!--设置菜单默认选中条目-->
      <Menu mode="horizontal" :active-name="$route.path.split('/')[1]" @on-select="selectMenu">
        <div class="navicon-con" style="margin-left: 10px;margin-right: 14px;position: relative;">
          <!--菜单的缩进和展开功能-->
          <!-- :style="{transform: 'rotateZ(' + (this.sidebar ? '90' : '0') + 'deg)'}" -->
         <div v-if="sidebar" style="cursor: pointer;position: absolute;left: 14px;top: 50%;transform: translate(-50%,4%);"   @click="toggleSideBar">
           <svg-icon icon-class="default" style="color: #495060;font-size: 22px;" />
         </div>
         <div v-else style="cursor: pointer;position: absolute;left: 14px;top: 50%;transform: translate(-50%,4%);"   @click="toggleSideBar">
           <svg-icon icon-class="sq" style="color: #495060;font-size: 22px;" />
         </div>
        </div>
        <breadcrumbNav/>
        <div class="layout-nav">
          <div class="main-header-operate">
         <!-- <div class="header-avator-con-icon">
              <div>
                <screenfull style="margin-top: 4px"/>
              </div>
             <div>
               <themeDropMenu @on-select="selectMenu"/>
             </div>
            </div> -->
            <div class="header-avator-con" >
              <div class="user-dropdown-menu-con" style="margin-right: 20px;">
                <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                  <!-- <Avatar :src="avator" style="background: #2db7f5;margin-right: 15px;"></Avatar> -->
                  <img style="width: 32px;margin-right: 6px;" src="../../assets/headPortrait.png" alt="">
                  <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown" >
                    <a href="javascript:void(0)">
                      <span class="main-user-name">{{userName}}</span>
                      <!--下拉按钮，以后会用到-->
                      <Icon type="arrow-down-b"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem  style="border: none;" name="loginout" divided>退出登录</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                </Row>
              </div>
            </div>
          </div>
        </div>
      </Menu>
    </div>
    <div class="tags-con" >
      <tagsOpened  @on-select="selectMenu" :pageTagsList="pageTagsList"></tagsOpened>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import breadcrumbNav from './BreadcrumbNav.vue';
  import tagsOpened from './TagsOpened.vue';
  import screenfull from '@/components/main/Screenfull.vue';
  import themeDropMenu from '@/components/main/ThemeDropMenu.vue';
  import avator from '@/assets/avator.png';

  export default {
    name: 'navbar',
    components: {
      breadcrumbNav,
      tagsOpened,
      screenfull,
      themeDropMenu,
    },
    data() {
      return {
        avator: avator,
        buttonSize: 'small'
      };
    },
    props: ['menuActive'],
    computed: {
      pageTagsList() {
        return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
      },
      ...mapGetters([
        'sidebar',
        'userInfo',
        'name'
      ]),
      userName() {
        if (this.userInfo === null && this.userInfo !== "") {
          return ""
        } else {
          return this.userInfo.userName
        }
      },
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('ChangeSidebar')
      },
      handleClickUserDropdown(e) {
        if (e === "loginout") {
          this.$store.dispatch('LogOut').then(() => {
            location.reload();
            localStorage.clear();
            sessionStorage.clear();
          });
        }
      },
      //选中导航菜单回调
      selectMenu(name) {
        this.$emit("select", name);
      }
    }
  }
</script>
<style>
  .main-header .main-header-operate .header-avator-con .user-dropdown-menu-con{
        position: absolute;
        right: 0;
        top: 0;
        width: 300px !important;
        height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar.vue?14242790